import { render } from "./ProviderActionPopup.vue?vue&type=template&id=10ba8df0&scoped=true"
import script from "./ProviderActionPopup.vue?vue&type=script&lang=js"
export * from "./ProviderActionPopup.vue?vue&type=script&lang=js"

import "./ProviderActionPopup.vue?vue&type=style&index=0&id=10ba8df0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10ba8df0"]])

export default __exports__